export default {
    background: './image/bg.png',
    ground: './image/ground.png'
}